<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,10C12,10.55,12.45,11,13,11C13.28,11,13.53,10.89,13.71,10.71C13.71,10.71,15.71,8.71,15.71,8.71C15.89,8.53,16,8.28,16,8C16,7.72,15.89,7.47,15.71,7.29C15.71,7.29,13.71,5.29,13.71,5.29C13.53,5.11,13.28,5,13,5C12.45,5,12,5.45,12,6C12,6.28,12.11,6.53,12.29,6.71C12.29,6.71,12.59,7,12.59,7C12.59,7,9,7,9,7C9,7,9,2,9,2C9,2,12,2,12,2C12,2,12,3.71,12,3.71C12.31,3.58,12.64,3.5,13,3.5C13.36,3.5,13.69,3.58,14,3.71C14,3.71,14,1,14,1C14,0.45,13.55,0,13,0C13,0,3,0,3,0C2.45,0,2,0.45,2,1C2,1,2,3.71,2,3.71C2.31,3.58,2.64,3.5,3,3.5C3.36,3.5,3.69,3.58,4,3.71C4,3.71,4,2,4,2C4,2,7,2,7,2C7,2,7,7,7,7C7,7,3.41,7,3.41,7C3.41,7,3.7,6.71,3.7,6.71C3.89,6.53,4,6.28,4,6C4,5.45,3.55,5,3,5C2.72,5,2.47,5.11,2.29,5.29C2.29,5.29,0.29,7.29,0.29,7.29C0.11,7.47,0,7.72,0,8C0,8.28,0.11,8.53,0.29,8.71C0.29,8.71,2.29,10.71,2.29,10.71C2.47,10.89,2.72,11,3,11C3.55,11,4,10.55,4,10C4,9.72,3.89,9.47,3.71,9.29C3.71,9.29,3.41,9,3.41,9C3.41,9,7,9,7,9C7,9,7,14,7,14C7,14,4,14,4,14C4,14,4,12.29,4,12.29C3.69,12.42,3.36,12.5,3,12.5C2.64,12.5,2.31,12.42,2,12.29C2,12.29,2,15,2,15C2,15.55,2.45,16,3,16C3,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,12.29,14,12.29C13.69,12.42,13.36,12.5,13,12.5C12.64,12.5,12.31,12.42,12,12.29C12,12.29,12,14,12,14C12,14,9,14,9,14C9,14,9,9,9,9C9,9,12.59,9,12.59,9C12.59,9,12.3,9.29,12.3,9.29C12.11,9.47,12,9.72,12,10C12,10,12,10,12,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SplitColumns',
} as DefineComponent
</script>
